import { Box } from 'components/Box';
import { Hide } from 'components/Hide';
import {
  InputPrefixVariant,
  InputStyleVariant,
} from 'components/Input/Input.styled';
import { IdealistLogo } from 'components/Logo/IdealistLogo';
import { NoAmp } from 'containers/NoAmp';
import SearchInputsContainer from 'containers/SearchInputsContainer';
import StaffSearchInputsContainer from 'containers/StaffSearchInputsContainer';
import { colors, gutterWidth } from 'theme';

type Props = {
  onSearch: (arg0: {
    query?: string;
    type?: string;
    searchType?: string;
  }) => void;
  defaultSearchType?: DefaultSearchType;
  navSection: 'MAIN' | 'STAFF';
  qaId?: string;
  inPageHeader?: boolean;
  searchFrom?: string;
  searchMode?: boolean;
  prefixVariant?: InputPrefixVariant;
  styleVariant?: InputStyleVariant;
};

export function SearchMenu({
  onSearch,
  defaultSearchType,
  navSection,
  qaId = 'search-menu',
  inPageHeader,
  prefixVariant,
  searchFrom,
  searchMode,
  styleVariant,
}: Props) {
  const isStaff = navSection === 'STAFF';

  return (
    <NoAmp>
      <Box
        data-qa-id={qaId}
        classes={['flex', 'align-center']}
        position="relative"
        width="100%"
        // @ts-expect-error TS(2322): Type 'false | "white" | undefined' is not assignab... Remove this comment to see the full error message
        bg={inPageHeader && 'white'}
        // @ts-expect-error TS(2322): Type 'false | (number | null)[] | undefined' is no... Remove this comment to see the full error message
        pb={inPageHeader && [gutterWidth / 2, null, null, 16]}
        // @ts-expect-error TS(2322): Type 'false | (number | null)[] | undefined' is no... Remove this comment to see the full error message
        pt={inPageHeader && [gutterWidth / 2 + 60, null, null, 16]}
        // @ts-expect-error TS(2322): Type 'number | false | undefined' is not assignabl... Remove this comment to see the full error message
        px={inPageHeader && gutterWidth / 2}
        // @ts-expect-error TS(2322): Type 'false | "100%" | undefined' is not assignabl... Remove this comment to see the full error message
        height={inPageHeader && '100%'}
        // @ts-expect-error TS(2322): Type 'string | false | undefined' is not assignabl... Remove this comment to see the full error message
        borderTop={inPageHeader && `1px solid ${colors.inputGrey}`}
      >
        {inPageHeader && (
          // @ts-expect-error TS(2322): Type '{ children: Element; xs: true; sm: true; md:... Remove this comment to see the full error message
          <Hide xs sm md flex="0 0 auto">
            <Box height="100%" mr={[24, null, null, null, 40]}>
              <Box
                component="a"
                href={isStaff ? '/staff' : '/'}
                title={`Idealist${isStaff ? ' Staff' : ''}`}
                data-qa-id="header-logo-link"
                display="block"
                height="100%"
                lineHeight={0}
              >
                <IdealistLogo
                  withText
                  height={{ mobile: 36, desktop: 48 }}
                  withStaffMarker={isStaff}
                />
              </Box>
            </Box>
          </Hide>
        )}
        <Box
          flex="1 1 auto"
          width="100%"
          // @ts-expect-error TS(2322): Type 'false | "100%" | undefined' is not assignabl... Remove this comment to see the full error message
          height={inPageHeader && '100%'}
        >
          {isStaff ? (
            <StaffSearchInputsContainer
              onSearch={onSearch}
              searchSection={isStaff ? 'STAFF' : 'MAIN'}
              inPageHeader={inPageHeader}
              styleVariant={styleVariant}
              prefixVariant={prefixVariant}
            />
          ) : (
            <SearchInputsContainer
              onSearch={onSearch}
              searchSection={isStaff ? 'STAFF' : 'MAIN'}
              inPageHeader={inPageHeader}
              isStaff={false}
              searchFrom={searchFrom}
              // @ts-expect-error fix types
              defaultSearchType={defaultSearchType}
              // @ts-expect-error fix types
              searchMode={searchMode}
              styleVariant={styleVariant}
              prefixVariant={prefixVariant}
            />
          )}
        </Box>
      </Box>
    </NoAmp>
  );
}
